import React,{ useCallback, useEffect, useMemo, useState } from "react"
import { useHourlyActiveUser } from "../../hooks/useHourlyActiveUser"
import moment from "moment"
import _ from 'lodash'
import ReactECharts from 'echarts-for-react';
import active_user_bg from './img/active_user.svg'
import * as echarts from 'echarts/core';
import { blue } from "../../theme/colors";
import { useHitRate } from "../../hooks/useHitRate";
// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import hot from './img/hot.svg'
import { getCurrentIssueNumber } from "../../utils/util";
import { DrawResultType, getPreviousIssueNumbers, useLatestDraw } from "../../hooks/useDraw";
import { useK3Pics, useMotorPics,_5dBall, useWingoFlatPics, useWingoGrayPics, useWingoPics } from "../Draw/LotteryDrawAnim";
import wingo_circle_30s from '../Draw/wingoimg/wingo_circle_30s.svg'
import k3_circle_1m from '../Draw/k3img/k3_circle_1m.svg'
import d5_circle_1m from '../Draw/5dimg/5d_circle_1m.svg'
import trxwingo_circle_1m from '../Draw/wingoimg/trxwingo_circle_1m.svg'
import motor_circle_1m from '../Draw/motorimg/motor_circle_1m.svg'
import Spacer from "../../components/Spacer";
import { useTranslation } from "react-i18next";
 
const logos = [wingo_circle_30s,k3_circle_1m,d5_circle_1m,trxwingo_circle_1m,motor_circle_1m]
export const PopularLotteryPrediction = ()=>{
    const {data:hitRates,refresh} = useHitRate()
    const [chartData,setChartData] = useState<number[]>()
    const [xAxisData,setXAxisData]= useState<string[]>() 
    const [rate,setRate] = useState(0)
    const {refresh:refreshDraw} = useLatestDraw()
    const [draws,setDraws] = useState<{type:string,data:any}[]>()
    const {t} = useTranslation()
    const loadDraws = useCallback(async ()=>{
      // /MotoRace/MotoRace_1M/GetHistoryIssuePage.json
            // /WinGo/WinGo_1M/GetHistoryIssuePage.json
            // /D5/D5_1M/GetHistoryIssuePage.json
            // /K3/K3_1M/GetHistoryIssuePage.json
      const [wingo,k3,d5,trxwingo,motorace] = await Promise.all([
        refreshDraw('WinGo/WinGo_1M/GetHistoryIssuePage.json'),
        refreshDraw('K3/K3_1M/GetHistoryIssuePage.json'),
        refreshDraw('D5/D5_1M/GetHistoryIssuePage.json'),
        refreshDraw('TrxWinGo/TrxWinGo_1M/GetHistoryIssuePage.json'),
        refreshDraw('MotoRace/MotoRace_1M/GetHistoryIssuePage.json'),
      ])
      setDraws([{type:'wingo',data:wingo},
        {type:'k3',data:k3},
        {type:'5d',data:d5},
        {type:'trxwingo',data:trxwingo},
        {type:'motorace',data:motorace},
      ])
    },[])
    useEffect(()=>{
      
      loadDraws()
      let i = setInterval(() => {
          loadDraws()
      }, 30*1000);
      return ()=>clearInterval(i)
    },[])
    // useLatestDraw('WinGo_1_'+getCurrentIssueNumber)
    // useEffect(()=>{
    //   let i = setInterval(() => {
    //     // // setRate(_.random(80,96))
    //     // refresh()
    //   }, 60*1000);
    //   return ()=>clearInterval(i)
    // })
    // useEffect(()=>{
    //   const issueNumberWinGo1m = getCurrentIssueNumber(1,new Date())
    //   const issueNumberWinGo3m =  getCurrentIssueNumber(2,new Date())
    //   const issueNumberWinGo5m =  getCurrentIssueNumber(3,new Date())
    //   const issueNumberWinGo30s =  getCurrentIssueNumber(30,new Date())
    //   console.log('issueNumberWinGo30s',issueNumberWinGo1m,issueNumberWinGo3m,issueNumberWinGo5m,issueNumberWinGo30s)
    // })
    const wingoGrayPics = useWingoGrayPics()
    const wingoPics = useWingoPics()
    if(!draws){
      return <></>
    }
    return <div style={{alignSelf:'stretch',position:'relative'}}>
      <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontWeight:'bold'}}> 
        <img src={hot} style={{width:20,height:20,marginLeft:10,marginRight:10}}/>{t('Popular Lottery Predictions')}
      </div>
      {draws?.map((draw,index)=>{
        // if(!draw.data){
        //   return <></>
        // }
        return <div onClick={()=>{
        let url
        switch(index){
          case 0:
            url = '#/wingo_30s'
            break
          case 1:
            url = '#/k3_1m'
            break
          case 2:
            url = '#/5d_3m'
            break
          case 3:
            url = '#/trxwingo_1m'
            break
          case 4:
            url = '#/moto_1m'
            break
        }
        window.open(url,'_blank')
      }} style={{padding:10,alignSelf:'stretch',flex:1,justifyContent:'space-around',flexDirection:'row',display:'flex',backgroundColor:'white',borderRadius:10,margin:10,boxShadow:'0px 6px 12px rgba(0, 0, 0, 0.08)'}}>
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',fontSize:12,fontWeight:'bold'}}>
            <img style={{width:80,height:80}} src={logos[index]}/>
            {/* @ts-ignore */}
            {/* WinGo {draw.typeId+(draw.typeId==30?'s':'m')} */}
            <LotteryDesc type={draw.type}/>
          </div>
          {/* <div style={{width:10,height:10}}/> */}
          <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
            <div style={{display:'flex',flexDirection:'column',flex:1,justifyContent:'center'}}>
              <div style={{color:'black',fontWeight:'bold',lineHeight:'90%'}}>{t('Draw No')}:{draw?.data?.data?.list?.[0]?.issueNumber}</div>
              <div style={{height:10}}/> 
              <DrawResult data={draw}/>
              <div style={{height:10}}/>
              <div style={{display:'flex',flexDirection:'row'}}>
                <div style={{background:blue[100],color:blue[900],paddingLeft:10,paddingRight:10,borderRadius:100,}}>{t('Pred. Results')}</div>
                <div style={{color:'#FB5B5B',background:'#FFEBEC',paddingLeft:10,paddingRight:10,marginLeft:10,borderRadius:100}}>{t('Bet Now')}</div>
              </div>
            </div>
          </div>
        </div>
      })}
    </div>
  }

const LotteryDesc = ({type}:{type:string})=>{
  const res = useMemo(()=>{
    switch(type){
      case 'wingo':
        return 'WinGo 30s'
      case 'trxwingo':
        return 'Trx WinGo 1m'
      case 'k3': 
        return 'K3 1m'    
      case '5d':
        return '5D 1m'   
      case 'motorace':
        return 'Moto Racing 1m'   
    }
  },[type])
  return <div>{res}</div>
}
const DrawResult = ({data}:{data:{type:string,data:{data:{list:any[]}}}})=>{
  const wingoPics = useWingoPics()
  const wingoGrayPics = useWingoGrayPics()
  const k3Pics = useK3Pics()
  const motorPics = useMotorPics()
  if(!data.data){
    return <></>
  }
  if(data.type=='wingo'||data.type=='trxwingo'){
    const nums = _.take(data.data.data.list,5).map((item:any)=>item?.number).join('')
    return <div>{nums.split('').map((item:string,index:number)=>{
        const itemNum = parseInt(item)
        return <img src={index==0?wingoPics[itemNum]:wingoGrayPics[itemNum]} style={{width:28,height:28,marginRight:10}}/>
      })}</div>
  }
  if(data.type=='k3'){
    const sum = data.data.data.list[0].premium.split('').reduce((acc:number,item:string)=>acc+parseInt(item),0)
    return  <div style={{color:'gray'}}>
          {data.data.data.list[0].premium.split('').map((item:string,index:number,arr:string[])=>{
            const itemNum = parseInt(item)
            return <><img src={k3Pics[itemNum]} style={{width:28,height:28}}/>
            <span style={{marginRight:5,marginLeft:5}}>
            {index==arr.length-1?'=':'+'}
            </span>
            </>
          })}
          <span style={{position:'relative'}}>
            <img src={k3Pics[0]} style={{width:28,height:28,}}/>
            <div style={{position:'absolute',height:28,left:0,right:0,top:0,bottom:0,color:'white',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>
              {sum}</div>
          </span>
        </div> 
  }
  if(data.type=='5d'){
    const sum = data.data.data.list?.[0].premium.split('').reduce((acc:number,item:string)=>acc+parseInt(item),0)
    return <>
      <div style={{display:'flex',flexDirection:'row'}}>{data.data.data.list?.[0].premium.split('').map((item:string,index:number,arr:string[])=>{
          return  <>
              <_5dBall width={'25px'} fontSize={'12px'} num={parseInt(item)} position={String.fromCharCode(65+index)}/>
             {index!=arr.length-1 && <div style={{marginLeft:3,marginRight:3}}>+</div>}
          </>
          // return item+'_'+index
      })}
      <div style={{marginLeft:5,marginRight:5,marginBottom:25}}>=</div><_5dBall width={'25px'} fontSize={'12px'} num={sum} position=''/>
    </div>
    </>
  }

  if(data.type=='motorace'){
    return <div style={{display:'flex',flexDirection:'row'}}>{data.data.data.list?.[0].premium.split(',').map((item:string,index:number)=>{
      const itemNum = parseInt(item)
      return <div style={{display:'flex',flexDirection:'column',marginRight:5}}>
        <div style={{color:'#FB5B5B',height:20,marginBottom:2}}>{index==0?'1st':''}</div>
        <img src={motorPics[itemNum]} style={{width:18,height:18}}/>
      </div>
    })}</div>
  }

  return <div>default</div>
      // return <div>{draw?.content?.premium.split('').map((item:string,index:number)=>{
      //           const itemNum = parseInt(item)
      //           return <img src={index==0?wingoPics[itemNum]:wingoGrayPics[itemNum]} style={{width:28,height:28,marginRight:10}}/>
              // })}</div>
              // <div>{draw.type}</div>
}